import i18n from 'i18next'

/**
 * Namespace prefix used for this app's browser storage (localStorage) keys.
 */
export const STORAGE_NAMESPACE = 'hivolution'

/**
 * Browser storage (localStorage) keys used by the app.
 */
export const STORAGE_KEY = {
  BUILD_ID: `${STORAGE_NAMESPACE}-buid`,
  THEME: `${STORAGE_NAMESPACE}-theme`,
  COLUMNS_VISIBILITY: `${STORAGE_NAMESPACE}-columns-visibility`
}

/**
 * Point time-series storage types.
 */
export const STORAGE_TYPES = {
  GAUGE: 'gauge',
  STATUS: 'status'
}

/**
 * Field names of a point's `time_series_storage_info` object.
 */
export const TIME_SERIES_STORAGE_INFO_FIELDS = {
  POINT_TYPE: 'point_type',
  PERIOD: 'period',
  STORAGE_ENABLED: 'storage_enabled',
  LINEAR_MULTIPLIER: 'linear_multiplier',
  LINEAR_CONSTANT: 'linear_constant',
  ACCEPTABLE_VALUES: 'acceptable_values'
}

/**
 * Translates a STORAGE_TYPES value into its display label.
 *
 * @param {string} value - STORAGE_TYPES value.
 * @returns {string} Translated label, or the original value if unmapped.
 */
export const getStorageTypes = value =>
  ({
    [STORAGE_TYPES.GAUGE]: i18n.t('common.gauge'),
    [STORAGE_TYPES.STATUS]: i18n.t('common.status')
  })[value] ?? value

/**
 * Returns the options for the storage type dropdown.
 *
 * @returns {{
 *   label: string, // Translated display label.
 *   value: string // Underlying option value.
 * }[]} Option list.
 */
export const getStorageTypeOptions = () => [
  { label: i18n.t('common.gauge'), value: STORAGE_TYPES.GAUGE },
  { label: i18n.t('common.status'), value: STORAGE_TYPES.STATUS }
]
